import { useNavigate } from "react-router-dom";
import { appRoutes, LANDING_PATH_SEARCH_DOCTOR } from "../../constants/routes";

export const useNav = () => {
  const navigate = useNavigate();

  return {
    navLogin: () => navigate(appRoutes.login),
    navSurvey: () => navigate(appRoutes.survey),
    navExperts: () => navigate(LANDING_PATH_SEARCH_DOCTOR),
    navProfessionals: () => navigate("/psiconcologi"),
    navContacts: () => navigate("/contatti"),
  };
};
